import { render, staticRenderFns } from "./SwipeDemo.vue?vue&type=template&id=c3ba9b6a&"
import script from "./SwipeDemo.vue?vue&type=script&lang=js&"
export * from "./SwipeDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports